import {Tooltip} from 'platform/components';
import {Heading, HStack, Icon} from 'platform/foundation';

interface CalculatorControlHeadingProps {
  title: string;
  tooltip: string;
  testId: string;
}

export function CalculatorControlHeading(props: CalculatorControlHeadingProps) {
  return (
    <HStack spacing={1} align="center">
      <Heading size={4}>{props.title}</Heading>
      <Tooltip description={props.tooltip}>
        <Icon
          value="action/help"
          color="text.secondary"
          size={4}
          tabIndex={0}
          data-testid={props.testId}
        />
      </Tooltip>
    </HStack>
  );
}
